<template>
  <div class="serviceChart mainContent" v-if="showFlag">
    <div class="mainWidth chartContent">
      <div class="TabTit">
        <dl class="clearfix">
          <dt style="color:#fff">
            <img
              src="../../assets/images/titleicon5.png"
              alt=""
            >
            服务成效统计
          </dt>
        </dl>
      </div>
      <ul class="clearfix">
        <li>
          <div class="chartTit">
            <span>平均办理时长</span>
            <span>事项开放清单总量</span>
          </div>
          <div
            id="pie1"
            class="clearfix"
          >
            <div class="bt1">
              <div class="insidePie"></div>
              <p><b>{{statisticsObj.day}}</b>天</p>
              <p><b>{{statisticsObj.hour}}</b>小时</p>
            </div>
            <div class="bt2">
              <div class="insidePie"></div>
              <p>{{statisticsObj.sxkfqdzl}}</p>
              <p>个</p>
            </div>
          </div>
        </li>
        <li>
          <div class="chartTit">
            <span>各类事项数量占比</span>
          </div>
          <div
            ref="pie1_chart_ref"
            id="pie2"
          ></div>
        </li>
        <li>
          <div class="chartTit">
            <span>今日办理事项数量</span>
            <span>今日办结事项数量</span>
          </div>
          <div
            id="pie3"
            class="clearfix"
          >
            <div class="bt1">
              <div class="insidePie"></div>
              <p>{{statisticsObj.jrblsxsl}}</p>
              <p>个</p>
            </div>
            <div class="bt2">
              <div class="insidePie"></div>
              <p>{{statisticsObj.jrbjsxsl}}</p>
              <p>个</p>
            </div>
          </div>
        </li>
        <li class="trafficStatistics">
          <div class="chartTit">
            <span>今日访问量</span>
          </div>
          <img
            src="../../assets/images/user_icon.png"
            alt=""
          >
          <p>
            <b>{{ todayVisit }}</b>个
          </p>
        </li>
        <li>
          <div class="chartTit">
            <span>近一年办件量统计</span>
          </div>
          <div class="yearNumbersAll clearfix">
            <span class="pull-left">办件总量</span>
            <ul class="pull-left">
              <template v-for="(item, index) in bjTotalList">
                <li :key="index">{{item}}</li>
              </template>
            </ul>
            <b class="pull-left">件</b>
          </div>
          <div class="yearNumbers_1 pull-left">
            <div class="yearNumbersTit">
              <span>学生办件量</span>
            </div>
            <p>
              <b>{{statisticsObj.student}}</b>件
            </p>
          </div>
          <div class="yearNumbers_2 pull-left">
            <div class="yearNumbersTit">
              <span>教职工办件量</span>
            </div>
            <p>
              <b>{{statisticsObj.teacher}}</b>件
            </p>
          </div>
        </li>
        <li>
          <div class="chartTit">
            <span>近一年好差评统计</span>
          </div>
          <div
            id="pie4"
            ref="pie2_chart_ref"
          ></div>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
// 服务成效统计接口
import * as apiObj from "@/api/index-fwcxtj.js";
import { request } from "@/api/axios.js";
import { getStatisticConfig } from "@/api/deptHome.js";
export default {
  data() {
    return {
      // 服务成效统计数据
      statisticsObj: {
        // 平均办理时长 天
        day: "",
        // 平均办理时长 小时
        hour: "",
        // 事项开放清单总量
        sxkfqdzl: "",
        // 今日办理事项数量
        jrblsxsl: "",
        // 今日办结事项数量
        jrbjsxsl: "",
        // 近一年办件统计  总
        total: "",
        // 近一年办件统计  学生
        student: "",
        // 近一年办件统计 教师
        teacher: ""
      },
      // 办件总量的数组
      bjTotalList: [],
      // 请求数据
      paramData: {},
      // 服务成效统计是否展示
      showFlag: false,
      // 今日访问量
      todayVisit: "",
    };
  },
  mounted() {
    const deptCode = this.$route.query.code;
    if (deptCode && this.$route.path === "/depart") {
      this.paramData = {
        deptCode
      };
    }
    // 获取是否展示的信息
    this.getStatisticConfig();
  },
  methods: {
    // 获取今日访问量
    async getVisitNum() {
      let res = null;
      try {
        res = await request({
          method: "get",
          url: "portal-ywtb/web/guidelineVisit/findVisit"
        });
      } catch (error) {
        //
        return;
      }
      this.todayVisit = res.data;
    },
    /**
     * @name getStatisticConfig
     * @description 获取服务成效统计开关
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-22 16:40:55
     */
    async getStatisticConfig() {
      let res = null;
      try {
        let data = {
          ...this.paramData
        };
        if (!(this.$route.query.code && this.$route.path === "/depart")) {
          data.deptCode = "-1";
        }
        res = await getStatisticConfig(data);
      } catch (error) {
        this.showFlag = false;
        return Promise.reject();
      }
      if (res.data && res.data.status === 0) {
        // 不展示
        this.showFlag = false;
      } else {
        this.showFlag = true;
        // 获取服务成效统计数据
        this.getFwcxtjData();
      }
    },
    /**
     * @name getFwcxtjData
     * @description 获取服务成效统计数据
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 09:30:39
     */
    getFwcxtjData() {
      // 平均办理时长
      this.getAvgTransactionTime();
      // 事项开放清单总量
      this.getGuidelineTotal();
      // 主题分类事项数量对比
      this.getGuidelineSceneStatistical();
      // 今日办理事项数量
      this.getTransactionGuidelineToDay();
      // 今日办结事项数量
      this.getEndGuidelineToDay();
      // 近一年办件统计
      this.getGuidelineStatisticalNearYear();
      // 近一年好差评统计
      this.getGuidelineSuggestionNearYear();
      // 今日访问量
      this.getVisitNum();
    },
    /**
     * @name getAvgTransactionTime
     * @description 获取平均办理时长
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 09:32:07
     */
    async getAvgTransactionTime() {
      let res = null;
      try {
        res = await apiObj.getAvgTransactionTime({
          ...this.paramData
        });
      } catch (error) {
        // 接口错误
        return;
      }
      const hour = (res.data && res.data.blsc) || 0;
      // 根据市场计算天数和小时
      this.$set(this.statisticsObj, "day", Math.floor(hour / 24));
      this.$set(this.statisticsObj, "hour", hour % 24);
    },
    /**
     * @name getGuidelineTotal
     * @description 事项开放清单总量
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 09:41:27
     */
    async getGuidelineTotal() {
      let res = null;
      try {
        res = await apiObj.getGuidelineTotal({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      this.$set(this.statisticsObj, "sxkfqdzl", res.data.total || 0);
    },
    /**
     * @name getGuidelineSceneStatistical
     * @description 主题分类事项数量对比
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 09:45:42
     */
    async getGuidelineSceneStatistical() {
      let res = null;
      try {
        res = await apiObj.getGuidelineSceneStatistical({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      let legend = [];
      let seriesData = [];
      (res.data || []).map((item) => {
        legend.push(item.name);
        seriesData.push({
          name: item.name,
          value: item.value
        });
      });
      this.drawPie({
        dom: this.$refs.pie1_chart_ref,
        legend,
        color: ["#6F4DEA", "#FDBA39", "#30AAF2", "#01D285"],
        seriesData
      });
    },
    /**
     * @name getTransactionGuidelineToDay
     * @description 今日办理事项数量
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 10:22:55
     */
    async getTransactionGuidelineToDay() {
      let res = null;
      try {
        res = await apiObj.getTransactionGuidelineToDay({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      this.$set(this.statisticsObj, "jrblsxsl", res.data.total || 0);
    },
    /**
     * @name getEndGuidelineToDay
     * @description 进入办结事项数量
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 10:25:51
     */
    async getEndGuidelineToDay() {
      let res = null;
      try {
        res = await apiObj.getEndGuidelineToDay({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      this.$set(this.statisticsObj, "jrbjsxsl", res.data.total || 0);
    },
    /**
     * @name getGuidelineStatisticalNearYear
     * @description 近一年办件统计
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 10:28:33
     */
    async getGuidelineStatisticalNearYear() {
      let res = null;
      try {
        res = await apiObj.getGuidelineStatisticalNearYear({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      for (const key in res.data || {}) {
        this.$set(this.statisticsObj, key, res.data[key] || 0);
      }
      const str = String(this.statisticsObj.total || 0).padStart(6, "0");
      this.bjTotalList = str.split("");
    },
    /**
     * @name getGuidelineSuggestionNearYear
     * @description 近一年好差评统计
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 10:57:25
     */
    async getGuidelineSuggestionNearYear() {
      let res = null;
      try {
        res = await apiObj.getGuidelineSuggestionNearYear({
          ...this.paramData
        });
      } catch (error) {
        return;
      }
      // let legend = ["非常满意", "满意", "基本满意", "不满意", "非常不满"];
        let legend = ["非常不满", "不满意", "基本满意", "满意","非常满意"];
      let seriesData = [];
      const list = res.data || [];
      for (let i = 0, len = legend.length; i < len; i++) {
        const index = list.findIndex((item) => {
          return item.satisfaction === i + 1;
        });
        if (index > -1) {
          // 是这一项
          seriesData.push({
            name: legend[i],
            value: list[index]["VALUE"]
          });
        } else {
          seriesData.push({
            name: legend[i],
            value: 0
          });
        }
      }
      this.drawPie({
        dom: this.$refs.pie2_chart_ref,
        legend,
        color: ["#30AAF2", "#01D285", "#FDBA39", "#6F4DEA", "#FF3F3F"],
        seriesData
      });
    },
    /**
     * @name drawPie
     * @description echarts饼图
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-14 10:00:03
     */
    drawPie(params) {
      const { dom, legend, color, seriesData } = params;
      let myChart = this.$echarts.init(dom);
      let option = {
        title: {
          show: false
          // text: "各类事项数量占比",
          // textStyle: {
          //   color: "#fff",
          //   fontSize: "16",
          //   fontFamily: "MicrosoftYaHei"
          // },
          // left: "150",
          // top: "15"
        },
        grid: {
          bottom: 120,
          left: 0,
          right: "10%"
        },
        legend: {
          show: true,
          orient: "vertical",
          // top: legendTop,
          y: "center",
          right: "20",
          icon: "circle",
          textStyle: {
            fontSize: 16,
            rich: {
              name: {
                color: "#fff"
                // align: 'right'
                // width: 60
              },
              percent: {
                color: color,
                fontSize: 18,
                padding: [0, 5, 0, 10]
                // align: 'right'
              }
            }
          },
          formatter: function (name) {
            // 获取legend显示内容
            let data = seriesData;
            let total = 0;
            let tarValue = 0;
            for (let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                tarValue = data[i].value;
              }
            }
            if (total === 0) {
              return "{name| " + name + "}{percent|0.00%}";
            }
            let percent = ((tarValue / total) * 100).toFixed(2);
            return "{name| " + name + "}{percent|" + percent + "%}";
          },
          data: seriesData
        },
        // series: series,
        series: [
          // 主要展示层的
          {
            radius: ["15%", "75%"],
            center: ["28%", "50%"],
            type: "pie",
            itemStyle: {
              normal: {
                color: function (params) {
                  return color[params.dataIndex];
                }
              }
            },
            label: {
              normal: {
                show: false
              }
            },
            data: seriesData
          }, // 边框的设置
          {
            radius: ["86%", "88%"],
            center: ["28%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: "rgb(0, 157, 233,.34)"
              }
            },
            data: [
              {
                value: 1
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      // TODO 渲染完成后数据置为null，后期可能会有问题
      myChart = null;
      option = null;
    }
  }
};
</script>
<style lang="scss" scoped>
#pie3 {
  padding: 10px 30px;
}

#pie3 .bt1 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: left;
  background-color: #00c0ff;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie3 .bt2 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: right;
  background-color: #00d6a6;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie3 .bt1 p,
#pie3 .bt2 p {
  text-align: center;
  position: absolute;
  z-index: 2;
  width: 126px;
  font-size: 18px;
}

#pie3 .bt2 p:nth-child(2),
#pie3 .bt1 p:nth-child(2) {
  top: 40px;
  color: #00d6a6;
  font-size: 24px;
  font-weight: 700;
}

#pie3 .bt1 p:nth-child(2) {
  color: #00c0ff;
}

#pie3 .bt2 p:last-child,
#pie3 .bt1 p:last-child {
  top: 70px;
  color: #fff;
}

#pie1 {
  padding: 10px 20px;
}

#pie1 .bt1 {
  width: 126px;
  height: 126px;
  float: left;
  border-radius: 50%;
  background-color: #2ac2f5;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie1 .bt1:hover {
  background-color: #17c1fa;
}

#pie1 .bt2 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: right;
  background-color: #00d6a6;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie1 .bt2:hover {
  background-color: #09e2b3;
}

.insidePie {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #324f9b;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#pie1 .bt1 p {
  text-align: center;
  color: #fff;
  position: absolute;
  z-index: 2;
  width: 126px;
}

#pie1 .bt1 p b {
  color: #00c0ff;
  display: inline-block;
  padding: 0 4px;
  font-size: 18px;
}

#pie1 .bt1 p:nth-child(2) {
  top: 40px;
}

#pie1 .bt1 p:last-child {
  top: 70px;
}

#pie1 .bt2 p {
  text-align: center;
  position: absolute;
  z-index: 2;
  width: 126px;
  font-size: 18px;
}

#pie1 .bt2 p:nth-child(2) {
  top: 40px;
  color: #00d6a6;
  font-size: 24px;
  font-weight: 700;
}

#pie1 .bt2 p:last-child {
  top: 70px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Fwcxtj.vue